import React, { Fragment } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { Text, TextPreset, Tag, Color } from '@pegasus/ui-components/components/text';
import { injectConfig } from '@client/hoc/config';
import Translate from '@client/components/shared/translation/Translate';
import {
    ARTICLE_STATUS_RESERVED,
    ARTICLE_STATUS_SOLD_OUT,
} from '@client/config/constants';
import { ContactWidgetHelpIcon } from '@client/components/shared/SvgIcons';
import styles from './styles.scss';

export const AvailabilityBadge = ({ stockStatus, handleClick }) => {
    const isReserved = (stockStatus === ARTICLE_STATUS_RESERVED);
    const isSoldOut = (stockStatus === ARTICLE_STATUS_SOLD_OUT);

    return (
        <div
            styleName={classNames('badge', {
                'badge--reserved': isReserved,
                'badge--sold-out': isSoldOut,
            })}
        >
            <div styleName="badge-content" onClick={handleClick}>
                {isSoldOut && <Text preset={TextPreset.XXS} color={Color.bright}>
                    <Translate message="article.sold_out" />
                </Text>}
                {isReserved && (
                    <Fragment>
                        <Text preset={TextPreset.XXS} styleName="badge-text-wrapper" tag={Tag.DIV} color={Color.bright}>
                            <Translate message="article.reserved" />
                        </Text>
                        <ContactWidgetHelpIcon styleName="icon" />
                    </Fragment>
                )}
            </div>
        </div>
    );
};

AvailabilityBadge.propTypes = {
    handleClick: PropTypes.func.isRequired,
    stockStatus: PropTypes.string,
};

export default compose(
    injectConfig,
    CSSModules(styles, { allowMultiple: true }),
)(AvailabilityBadge);
